import { render } from "./PagePaginator.vue?vue&type=template&id=cec7d57c"
import script from "./PagePaginator.vue?vue&type=script&lang=js"
export * from "./PagePaginator.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__